import { render, staticRenderFns } from "./BusinessReport.vue?vue&type=template&id=2a3762c6&scoped=true"
import script from "./BusinessReport.vue?vue&type=script&lang=js"
export * from "./BusinessReport.vue?vue&type=script&lang=js"
import style0 from "./BusinessReport.vue?vue&type=style&index=0&id=2a3762c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a3762c6",
  null
  
)

export default component.exports